import { render } from "./KpiCard.vue?vue&type=template&id=abedb246&scoped=true"
import script from "./KpiCard.vue?vue&type=script&lang=js"
export * from "./KpiCard.vue?vue&type=script&lang=js"

import "./KpiCard.vue?vue&type=style&index=0&id=abedb246&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abedb246"]])

export default __exports__